import React from "react";
import { Tooltip } from "antd";

export const LCTooltip = ( props) => (
  <Tooltip {...props}>{props.children}</Tooltip>
);
